import { makeStyles } from '@material-ui/core';
import { Colors } from '../../../styles/Colors';

export const useStyles = makeStyles(() => ({
    header: {
        display: 'flex',
        flex: 1,
        alignItems: 'center',
        justifyContent: 'space-between',
        width: 'calc(100vw - 420px)',
        '& h2': {
            fontSize: 32,
            color: Colors.Text,
            lineHeight: '32px',
            margin: '0 16px 0 0'
        },
        '& p': {
            fontWeight: 500,
            fontSize: 32,
            color: Colors.Text,
        },
    },

    displayInline: {
        display:"inline-flex",
        flex:2
    },

    button: {
        marginTop: -14,
        paddingRight: 17,
        marginLeft: 20,
    },
    addIcon: {
        height: 22,
        width: 22,
        marginRight: 6,
        marginLeft: -3,
    },
    rightContainer: {
        display: 'flex',
        flexDirection: 'column',
    },
    outsideBalanceContainer: {
        display: 'flex',
        marginTop: 8,
        justifyContent: 'space-between'
    },
    statusBox: {
        border: `1px solid ${Colors.Primary2}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: Colors.Primary2,
        textTransform: 'uppercase',
        fontSize: 12,
        lineHeight: '20px',
        borderRadius: 5,
        minWidth: 230,
    },
    warningStatusBox: {
        border: `1px solid ${Colors.Error}`,
        color: Colors.Error,
    },
    balanceContainer: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        paddingRight: 33,
        minWidth: 80,
    },
    secondBalance: {
        paddingRight: 0,
    },
    semiHeader: {
        fontWeight: 400,
        color: Colors.Gray9,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        width: 'fit-content'
    },
    boldedValue: {
        fontWeight: 'bold',
    },
    value: {
        color: Colors.Text,
        lineHeight: '20px',
        whiteSpace: 'nowrap',
        paddingRight: 8
    },
}));
